var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideShowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84691 10.2709C5.23222 8.19808 8.13619 5 12.8676 5C17.5991 5 20.503 8.19808 21.8883 10.2709C22.3532 10.9665 22.5857 11.3143 22.5645 11.9569C22.5433 12.5995 22.2765 12.9469 21.7429 13.6417C20.1537 15.7107 16.9806 19 12.8676 19C8.75467 19 5.58151 15.7107 3.99238 13.6417C3.45874 12.9469 3.19191 12.5995 3.17076 11.9569C3.1496 11.3143 3.38204 10.9665 3.84691 10.2709ZM12.8676 16C15.0768 16 16.8676 14.2091 16.8676 12C16.8676 9.79086 15.0768 8 12.8676 8C10.6585 8 8.86762 9.79086 8.86762 12C8.86762 14.2091 10.6585 16 12.8676 16Z",
    fill: "#F6F7F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideShowWhite);
export default __webpack_public_path__ + "static/media/hide_show_white.45b12d18aadd7dba59355e67a5b5a1ea.svg";
export { ForwardRef as ReactComponent };